<template>
  <thead>
    <tr>
      <th
        v-for="column in columns.filter((column) => column.type !== 'hidden')"
        :key="'dataTableColumn_' + column.key"
        class="px-4 py-3 bg-gray-50 text-gray-800 text-xs border-b border-gray-200 font-medium text-left sticky top-0 z-20"
        :class="{
          'text-center': column.align === 'center',
          'text-end': column.align === 'right',
        }"
      >
        <sort-button
          v-if="column.sortable"
          :label="column.label ? column.label : column.key"
          :column="column.key"
          @sort="handleSort"
          :value="getSortValue(column.key)"
        />
        <span v-else>{{ column.label ? column.label : column.key }}</span>
      </th>
      <!-- Actions column. Uses w-0 so it grows perfectly to the content -->
      <th
        class="w-0 py-3 bg-gray-50 text-gray-500 text-xs border-b border-gray-200 font-medium text-left sticky top-0 z-20"
        id="actions"
      ></th>
    </tr>
  </thead>
</template>

<script setup>
import SortButton from "@/Tailwind/Components/Buttons/SortButton";
import { useFilters } from "@/Tailwind/Mixins/useFilters";

const props = defineProps({
  columns: {
    type: Array,
    required: true,
  },
  filterStoreKey: {
    type: String,
    required: true,
  },
});

// Sorting
const { handleSort, getSortValue } = useFilters(props.filterStoreKey);
</script>
